module.exports = __webpack_public_path__ + "name=img/node_modules/html5-device-mockups/device-mockups/iPad/portrait_white.png?37f8df723e021a3496e8018b2b8b906c";